import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { BackendPagination } from "../models/pagination.model";
import { TablePagination } from "../models/components/table/table-pagination.model";

export const useBiometricsSentReport = (participantId: number, pagination: TablePagination) => {
	const queryClient = useQueryClient();
	const queryKey = ["sent-reports", { participantId }];
	const query = useQuery({
		queryKey: ["sent-reports", { participantId, pagination }],

		queryFn: async () => {
			const backendPagination = new BackendPagination(pagination);
			return await EndpointsService.dataRetriever.getSentReports({
				participantId,
				config: { params: backendPagination },
			});
		},

		// Poll every 10 seconds to refresh status
		refetchInterval: 10000,

		refetchIntervalInBackground: false,
		enabled: !!participantId,
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
